import { Aurelia, autoinject, bindable } from 'aurelia-framework';
import { EventAggregator } from 'aurelia-event-aggregator';
import { AccountImportService } from './account-import-service';
import { RowValidationErrorModel } from '../../../models/row-validation-error-model';

@autoinject
export class AccountsImport {
	@bindable accountChartId;

	submitting: boolean;
	submitted: boolean;
	errors: RowValidationErrorModel[];

	constructor(private importService: AccountImportService) {
		this.submitting = false;
		this.submitted = false;
		this.errors = null;
	}

	submit(): void {
		this.submitting = true;
		this.submitted = false;
		this.errors = null;
		const accountData = this.importService.cleanAccountData();

		this.importService.submitData(accountData, this.accountChartId)
			.then(this.handleResponse.bind(this))
			.catch(error => {
				this.submitting = false;
			});
	}

	handleResponse(response): void {
		if (response.status !== 200) {
			response.json().then((errors) =>
				this.errors = RowValidationErrorModel.createFromValidationErrors(errors));
		} else {
			this.submitted = true;
		}
		this.submitting = false;
	}
}
